import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { IEditFirmwareContext, EditFirmwareContext } from '../../editFirmwareState/editFirmwareContext';
import FirmwareTypeSelect from './components/FirmwareTypeSelect';
import NameFirmwareInput from './components/NameFirmwareInput';
import VersionOfFirmwareInput from './components/VersionOfFirmwareInput';
import DescriptionInput from './components/DescriptionInput';
import FirmwareSettings from './components/FirmwareSettings';
import BtnBlock from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './EditForm.module.scss';

const EditForm: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setTypeSelectedFirmware,
		changeNameOfFirmware,
		changeVersionOfFirmware,
		changeDescription,
		id,
		typeSelectedFirmware,
		nameOfFirmware,
		versionOfFirmware,
		description,
		fileData,
	} = useContext<IEditFirmwareContext>(EditFirmwareContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			typeSelectedFirmware: typeSelectedFirmware,
			nameOfFirmware: nameOfFirmware,
			versionOfFirmware: versionOfFirmware,
			description: description,
		});
	}, [typeSelectedFirmware, nameOfFirmware, versionOfFirmware, description]);

	const submit = async () => {
		setDataForSubmit({
			id: id,
			name: nameOfFirmware,
			description: description,
			version: versionOfFirmware,
			type: typeSelectedFirmware || 1,
			fileId: fileData.fileId ? fileData.fileId : '',
			fileHash: fileData.fileHash ? fileData.fileHash : '',
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="EditForm">
			<div className={style.formWrapper}>
				<Form
					form={form}
					name="basic"
					onFinish={submit}
					onKeyPress={preventDefaultForEnterKey}
					layout="vertical">
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="mainInfoHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<FirmwareTypeSelect setTypeSelectedFirmware={setTypeSelectedFirmware} />
						<NameFirmwareInput changeNameOfFirmware={changeNameOfFirmware} />
						<VersionOfFirmwareInput changeVersionOfFirmware={changeVersionOfFirmware} />
						<DescriptionInput changeDescription={changeDescription} />
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="firmwareSettingsHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<Text
							className={style.requiredLabel}
							translationNameSpace="form"
							translationKey="requiredLabel"
							theme="secondary"
							size="s"
							weight="bold"
							display="inline"
						/>
						<FirmwareSettings />
					</div>
					<BtnBlock />
				</Form>
			</div>
		</div>
	);
};

export default EditForm;
